import { Col, Form, Input, Row } from 'antd';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import InputNumber from '../../../../../../../../../components/form/inputs/InputNumber';
import InputGeo from '../../../../../../../../../components/common/inputs/InputGeo';
import { EnrollmentFormContext } from '../../../../../../../../../providers/EnrollmentFormContextProvider';

const messageRequiredData = 'Dato requerido';

const AddressCivilPartner = ({ gutter, title, index }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  return (
    <>
      <Row>
        <Col span={24}>
          <p className="personalDocumentsForm__title">{title}</p>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col span={24}>
          {/* <Form.Item rules={[{ message: messageRequiredData }]}>
            <Checkbox onChange={handleSameAdress}>Usar mismo domicilio particular</Checkbox>
          </Form.Item> */}
        </Col>
      </Row>
      <InputGeo
        form={enrollmentForm}
        countryName={['legalRepresentatives', index, 'partner', 'address', 'country']}
        regionName={['legalRepresentatives', index, 'partner', 'address', 'region']}
        cityName={['legalRepresentatives', index, 'partner', 'address', 'city']}
      />
      <Row gutter={gutter}>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'partner', 'address', 'streetName']}
            label="Calle/Avenida"
            rules={[{ required: true, message: messageRequiredData }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col lg={6} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'partner', 'address', 'streetNumber']}
            label="Número"
            rules={[{ required: true, message: messageRequiredData }]}
          >
            <InputNumber hideArrows />
          </Form.Item>
        </Col>
        <Col lg={6} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'partner', 'address', 'houseNumber']}
            label="Depto/Casa"
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

AddressCivilPartner.propTypes = {
  gutter: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
};

export default AddressCivilPartner;
